import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface BibliographyRealDetailBibliography {
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  displayMaterialFormat: SystemCode
  displayClass: string
  displayTitle: string
  displaySubtitle: string
  displayAuthor: string
  volume: string
  volumeNumber: string
  volumeTotal: string
  volumeDateLabel: string
  volumeSpecial: string
  displayPublisher: string
  displayPublished: string
  bibliographySetId: number | null
  holdingCount: number
  orderCount: number
  reserveCount: number
  selectionCount: number
  collectionFlag: CollectionFlag
  revision: number
  isNewestVolume: boolean
  existsParentBibliographyAutoOrderInfo: boolean
}

export function BibliographyRealDetailBibliographyFromJSON(
  json: any
): BibliographyRealDetailBibliography {
  return {
    bibliographyClass: json.bibliography_class,
    prefix: json.prefix,
    bibliographyId: json.bibliography_id,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayMaterialFormat: exists(json, 'display_material_format')
      ? SystemCodeFromJSON(json.display_material_format)
      : defaultSystemCode(),
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displaySubtitle: exists(json, 'display_subtitle')
      ? json.display_subtitle
      : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    volume: exists(json, 'volume') ? json.volume : '',
    volumeNumber: exists(json, 'volume_number') ? json.volume_number : '',
    volumeTotal: exists(json, 'volume_total') ? json.volume_total : '',
    volumeDateLabel: exists(json, 'volume_date_label')
      ? json.volume_date_label
      : '',
    volumeSpecial: exists(json, 'volume_special') ? json.volume_special : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    bibliographySetId: exists(json, 'bibliography_set_id')
      ? json.bibliography_set_id
      : null,
    holdingCount: json.holding_count,
    orderCount: json.order_count,
    reserveCount: json.reserve_count,
    selectionCount: json.selection_count,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: json.revision,
    isNewestVolume: exists(json, 'is_newest_volume')
      ? json.is_newest_volume
      : false,
    existsParentBibliographyAutoOrderInfo: exists(
      json,
      'exists_parent_bibliography_auto_order_info'
    )
      ? json.exists_parent_bibliography_auto_order_info
      : false
  }
}

export const defaultBibliographyRealDetailBibliography = (): BibliographyRealDetailBibliography => ({
  bibliographyClass: BibliographyClass.Real,
  prefix: Prefix.Real,
  bibliographyId: 0,
  searchType: defaultSystemCode(),
  displayMaterialFormat: defaultSystemCode(),
  displayClass: '',
  displayTitle: '',
  displaySubtitle: '',
  displayAuthor: '',
  volume: '',
  volumeNumber: '',
  volumeTotal: '',
  volumeDateLabel: '',
  volumeSpecial: '',
  displayPublisher: '',
  displayPublished: '',
  bibliographySetId: null,
  holdingCount: 0,
  orderCount: 0,
  reserveCount: 0,
  selectionCount: 0,
  collectionFlag: CollectionFlag.NotCollection,
  revision: 0,
  isNewestVolume: false,
  existsParentBibliographyAutoOrderInfo: false
})
